import { Box, Button, Typography } from '@mui/material';
import React from 'react';
import { useDevSettings } from '../../../contexts/DevSettingsContext';
import { useHubPetParent } from '../HubPetParentContext';
import { track } from '../analytics';

const UPGRADE_URL = 'https://petcademy.org/pricing/?utm_source=hub&utm_medium=albums';

function UpgradeMembershipBanner() {
  const { enhancePetParentData } = useDevSettings();
  const { petParent: realData } = useHubPetParent();
  const petParent = enhancePetParentData(realData);
  const { trialStatus, premiumStatus } = petParent;

  const getContent = () => {
    if (premiumStatus === 'active') {
      return null;
    }

    if (trialStatus === 'expired' && premiumStatus === 'expired') {
      return {
        text: 'Your Petcademy membership has expired. Renew now to unlock editing and add new memories to your albums.',
        buttonText: 'Renew Membership',
      };
    }

    return {
      text: (
        <>
          Enjoy one complimentary album with your adoption.
          {' '}
          <b>Upgrade</b>
          {' '}
          to
          unlock all albums and capture every memory.
        </>
      ),
      buttonText: 'Upgrade Membership',
    };
  };

  const content = getContent();

  if (!content) {
    return null;
  }

  return (
    <Box
      sx={{
        background: '#E8E1F4',
        borderRadius: '12px',
        padding: 3,
        display: 'flex',
        gap: 1.5,
        alignItems: 'center',
        flexDirection: {
          xs: 'column',
          md: 'row',
        },
      }}
    >
      <Typography variant="body1" color="primary">
        {content.text}
      </Typography>
      <Button
        variant="hubButton"
        color="primary"
        onClick={() => {
          track('extend_membership_click', { from_where: 'albums' }, () => {
            window.open(UPGRADE_URL, '_blank', 'noopener');
          });
        }}
        sx={{
          whiteSpace: 'nowrap',
          flexShrink: 0,
          width: {
            md: 'auto',
          },
        }}
      >
        {content.buttonText}
      </Button>
    </Box>
  );
}

export default UpgradeMembershipBanner;
